module.exports = __webpack_public_path__ + "static/media/cq_pratiche b.c7b7a194.svg";